import dynamic from 'next/dynamic'
import React from 'react'

import ConnectWalletToContinue from '@/components/common/ConnectWalletToContinue'
import useNemoWallet from '@/hooks/use-nemo-wallet'
import { MainLayout } from '@/layouts/MainLayout'
import gssp from '@/utils/gssp'

const History = dynamic(() => import('@/components/history'), { ssr: false })

const HistoryPage = () => {
  const { publicKey } = useNemoWallet()

  return (
    <MainLayout hasContainer={false}>
      {publicKey ? <History /> : <ConnectWalletToContinue />}
    </MainLayout>
  )
}

export default HistoryPage

export const getServerSideProps = gssp()
